import "./Loader.scss";

export default function Loader({ type, text }) {
  return (
    <div className={type === undefined ? `loader` : `loader ${type}`}>
      <div className="spinner-border" role="status"></div>
      <div>{text === undefined ? "در حال بارگزاری" : text}</div>
    </div>
  );
}
